import "animated-scroll-to";

export const clickableSuperscripts = function (el) {
    const sups = el.querySelectorAll("sup");
    sups.forEach(function (sup) {
        const text = sup.innerText;
        sup.addEventListener("click", function (evt) {
            animateScrollTo(document.querySelector(".item-" + text), {
                easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
                minDuration: 100,
                maxDuration: 500,
                speed: 1000,
                verticalOffset: -100,
            });
        });
    });

    const references = el.querySelectorAll(".toReference");
    references.forEach(function (reference, i) {
        reference.addEventListener("click", function (evt) {
            animateScrollTo(document.querySelectorAll("sup")[i], {
                easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
                minDuration: 100,
                maxDuration: 500,
                speed: 1000,
                verticalOffset: -100,
            });
        });
    });
};
